<app-header [salesRep]="isSalesRep$ | async"
            [admin]="isAdmin$ | async"
            [menuItems]="menuItems$ | async"
            [customerSelected]="isCustomerSelected$ | async"
            [loggedIn]="isLoggedIn$ | async"
            [cart]="cart$ | async"
            [currency]="currency$ | async"
            [viewMode]="viewMode"
            [logoUrl]="logoUrl"
            [catalogRoute]="catalogRoute"
            [onNavigation]="navigateUrl$ | async"
            [searchTerm]="searchTerm$ | async"
            [user]="user$ | async"
            [pages]="catalogPages$ | async"
            [isSimplified]="simplifiedHeader$ | async"
            [navigateUrl]="navigateUrl$ | async"
            [languages]="languages$ | async"
            [topMenuStyle]="topMenuStyle$ | async"
            (onSearch)="onSearch($event)"
            (onSelectCustomer)="selectCustomer()"
            (onItemClick)="itemClick()"
            *ngIf="(isLoggedIn$ | async) && (isCustomerSelected$ | async)">
</app-header>

<div class="content" [ngClass]="{ 'make-room-for-header' : showHeader }">

    <!-- breadcrumbs
    <app-breadcrumbs
      [crumbs]="crumbs$ | async"
      *ngIf="((tenantSettings$ | async).show_breadcrumbs) && ((crumbs$ | async)?.length > 1) && (showCrumbs$ | async)  && ((isLoggedIn$ | async) && (isCustomerSelected$ | async))">
    </app-breadcrumbs>
    -->

    <!-- content -->
    <app-outlet></app-outlet>

  </div>

<app-footer
  *ngIf="((isLoggedIn$ | async) && (isCustomerSelected$ | async)) && !(globalProductsIsLoading$ | async) && ((navigateUrl$ | async) !== '/checkout/second-step')">
</app-footer>
